import React from "react";
import Report from "../../../components/Report";
import { Description } from "../../../util/ReportUtil";
import Avatar from "@mui/material/Avatar";
import { titleCase } from "title-case";
import { Link } from "react-router-dom";
import LinkIcon from "@mui/icons-material/Link";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { copyText } from "../../../util/ReportUtil";
import { useIsAdmin } from "../../../util/AdminUtil";

const endpoint = "/specialEvents.json";

const SpecialEventsReport = (props) => {
  return <Report {...props} />;
};

const EventLocation = (props) => {
  const isAdmin = useIsAdmin();
  const html = props.value;
  const d = props.d;

  const url = `/map?id=${d.id}&lat=${d.latitude}&lng=${d.longitude}&type=SpecialEvents`;
  return (
    <div title={d.fullLocation}>
      <Link to={url} target="_blank" className="reportCell">
        <span dangerouslySetInnerHTML={{ __html: html }} />
      </Link>
      <LinkIcon fontSize="small" className="link-icon" />
      {isAdmin && (
        <div title="Click to Copy">
          <Typography
            variant="body2"
            className="hover-highlight"
            onClick={() => copyText(d.id.trim())}
          >
            <span>{d.id.trim()}</span>
          </Typography>
        </div>
      )}
    </div>
  );
};

const EventAreaFrom = (props) => {
  return (
    props.value.fromCounty +
    "," +
    props.value.fromCity +
    "," +
    props.value.fromState
  );
};

const SpecialEventMM = (props) => {
  if (props.value.mileMarker === "" || props.value.mileMarker === "null") {
    return "N/A";
  } else return props.value.mileMarker;
};

const tableColumns = [
  {
    field: "",
    numeric: false,
    label: "Area",
    excludeSort: false,
    CellTemplate: EventAreaFrom,
  },
  {
    field: "description",
    numeric: false,
    label: "Description",
    excludeSort: false,
    CellTemplate: Description,
  },
  {
    field: "location",
    numeric: false,
    label: "Location",
    CellTemplate: EventLocation,
  },
  {
    field: "",
    numeric: false,
    label: "Mile Marker",
    CellTemplate: SpecialEventMM,
  },
  { field: "closureDetails", numeric: false, label: "Closure Details" },
  { field: "timePeriods", numeric: false, label: "Time Period" },
  { field: "severity", numeric: false, label: "Severity" },
  { field: "source", numeric: false, label: "Source" },
];

const cardColumns = [
  {
    field: "",
    numeric: false,
    label: "Area",
    excludeSort: false,
    CellTemplate: EventAreaFrom,
  },
  { field: "closureDetails", numeric: false, label: "Closure Details" },
  { field: "timePeriods", numeric: false, label: "Time Period" },
  { field: "severity", numeric: false, label: "Severity" },
  { field: "source", numeric: false, label: "Source" },
];

const MyCardHeader = (props) => {
  const d = props.d;
  return titleCase(d.description) + " : " + d.road;
};

const MyCardSubHeader = (props) => {
  const d = props.d;
  return <EventLocation value={d.location} d={d} />;
};

const MyAvatar = (props) => {
  return (
    <Avatar
      alt="Special Events"
      src="/mapicons/SpecialEvents/Special_Event_v14.png"
      aria-label="Incident"
      sx={{ width: 21, height: 21 }}
    ></Avatar>
  );
};

const DescriptionBlock = (props) => {
  return (
    <Box sx={{ pl: 2, mb: 1 }}>
      <Typography variant="body1">
        Hover over a location to see its municipality and county, or click on
        the location to see the map of the event.
      </Typography>
    </Box>
  );
};

const module = {
  routeProps: {
    path: "SpecialEventsReport",
    component: SpecialEventsReport,
  },
  name: "Special Events",
  label: "Special Events",
  title: "Special Events Report",
  showOnMenu: true,
  endpoint: endpoint,
  tableColumns: tableColumns,
  cardColumns: cardColumns,
  tabularFormat: true,
  orderBy: null,
  cardHeader: MyCardHeader,
  cardSubHeader: MyCardSubHeader,
  cardAvatar: MyAvatar,
  descriptionBlock: DescriptionBlock,
};

export default module;
